export default __webpack_public_path__ + "static/media/Group_587.61815592.svg";